import React, { useState } from 'react';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import styles from './OverviewImage.module.scss';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
}

export const OverviewImage: React.FC<Props> = ({ program }) => {
	const imageUrl = program?.studentFacingAcademicPartner.image;
	const [showImage, setShowImage] = useState(true);
	const handleError = () => setShowImage(false);

	if (!showImage) {
		return null;
	}

	return (
		<img
			alt=''
			className={styles.institutionImage}
			data-testid='overview-image'
			hidden={!showImage}
			onError={handleError}
			src={imageUrl}
		/>
	);
};
